import { cn } from '../../lib/shadcn/utils'
import { humanize, operationalStateConfig } from '../../utils/statements'

// Operational state: a solid, colour-coded pill. Colours are fixed by spec.
export function OperationalStateChip({
  state,
  className,
}: {
  state: string | null | undefined
  className?: string
}) {
  const cfg = operationalStateConfig(state)
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        cfg.chip,
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', cfg.dot)} />
      {cfg.label}
    </span>
  )
}

// Lifecycle: deliberately styled differently from operational state — an
// outline pill in neutral/brand ink so the two concepts never read as the same.
export function LifecycleChip({
  status,
  className,
}: {
  status: string | null | undefined
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-dashed border-border bg-background px-2 py-0.5 text-xs font-medium text-foreground whitespace-nowrap',
        className,
      )}
    >
      {humanize(status)}
    </span>
  )
}

// A tiny caption used to label each chip so Lifecycle and Operational are never
// merged or confused.
export function ChipLabel({ children }: { children: string }) {
  return (
    <span className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      {children}
    </span>
  )
}
